import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkApiService {

  constructor(private http: HttpClient) {}

  readonly networkUrl = 'topology';
  readonly clusterUrl =  `${this.networkUrl}/cluster`;
  readonly syncUrl =  `${this.networkUrl}/sync`;
  readonly testRouteUrl = 'routing/testRoute';

  public getClusters(): Observable<any> {
    return this.http.get(this.clusterUrl);
  }

  public saveClustersStateToServer(clusters): Promise<any> {
    return this.http.put(this.clusterUrl, clusters).toPromise();
  }

  public syncTopology(): Promise<any> {
    return this.http.get(this.syncUrl).toPromise();
  }

  public testRoute(testRouteObj): Promise<any> {
    return this.http.post(this.testRouteUrl, testRouteObj).toPromise();
  }
}
